import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {fetchFarmUserDataAsync} from 'state/actions';
import {deposit, stake} from 'utils/callHelpers';
import {useWeb3React} from '@web3-react/core';
import {useMasterchef} from './useContract';


const useStake = (pid: number) => {
    const dispatch = useDispatch();
    const {account} = useWeb3React();
    const masterChefContract = useMasterchef();

    const handleStake = useCallback(
        async (amount: string) => {
            const txHash = await stake(masterChefContract, pid, amount, account);
            dispatch(fetchFarmUserDataAsync(account));
            console.info(txHash);
        },
        [account, dispatch, masterChefContract, pid],
    );

    return {onStake: handleStake};
};

export default useStake;


export const useDepositShef = () => {
    const dispatch = useDispatch();
    const {account} = useWeb3React();
    const masterChefContract = useMasterchef();

    const handleStake = useCallback(
        async (amount: string) => {
            try {
                const txHash = await deposit(masterChefContract, amount, account);
                dispatch(fetchFarmUserDataAsync(account));
                return txHash;
            } catch (e) {
                return false;
            }
        },
        [account, dispatch, masterChefContract],
    );

    return {onStake: handleStake};
};